<template>
    <div ref="floatingWrap" class="floating-wrap">
        <div class="floating-icon-top">
            <a href="#st-container" aria-label="콘텐츠 상단으로 이동" @click.prevent="goToTop"></a>
        </div>
        <div v-if="route.meta.showShare && hasShareInfo" class="floating-icon-share">
            <button type="button" aria-label="공유하기" @click="onShare"></button>
        </div>
    </div>
    <SharePopup ref="sharePopup" @close="closePopup" />
</template>

<script setup>
    import { onMounted, onUnmounted, ref, computed } from 'vue';
    import { useRoute } from 'vue-router';
    import { useRootStore } from '@/stores/modules';
    import SharePopup from '@/components/common/SharePopup.vue';

    const route = useRoute();
    const rootStore = useRootStore();

    const hasShareInfo = computed(() => {
        return !!(rootStore.shareInfo && Object.keys(rootStore.shareInfo).length > 0);
    });

    const floatingWrap = ref(null);
    const sharePopup = ref(null);
    const isPopupVisible = ref(false);

    const handleScroll = () => {
        if (!floatingWrap.value) {
            return;
        }

        if (window.scrollY >= 300) {
            floatingWrap.value.classList.add('on');
        } else {
            floatingWrap.value.classList.remove('on');
        }
    };
    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    const onShare = () => {
        if (sharePopup.value) {
            sharePopup.value.open();
        }
    };
    const closePopup = () => {
        isPopupVisible.value = false;
    };

    onMounted(() => {
        window.addEventListener('scroll', handleScroll);
    });
    onUnmounted(() => {
        window.removeEventListener('scroll', handleScroll);
    });
</script>

<script>
    export default {
        name: 'FloatingButton',
    };
</script>
